<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'
import ButtonIconOnly from '@/components/atoms/ButtonIconOnly.vue'
import IconDustBox from '@/components/icons/IconDustBox.vue'

type LineRichMenu = {
  guid: string
  label: string
}

const props = withDefaults(
  defineProps<{
    lineRichMenus: Array<LineRichMenu>
  }>(),
  {
    lineRichMenus: () => new Array<LineRichMenu>(),
  }
)

const emits = defineEmits<{
  (e: 'handleClickDeleteButton', guid: string, label: string): Promise<void>
}>()

const route = useRoute('LineRichMenuIndexPage')

const onClickDeleteButton = (lineRichMenu: LineRichMenu): void => {
  emits('handleClickDeleteButton', lineRichMenu.guid, lineRichMenu.label)
}
</script>

<template>
  <table :class="$style.table">
    <colgroup>
      <col />
    </colgroup>
    <thead>
      <tr>
        <th>ラベル</th>
        <th :class="$style.deleteButton"></th>
      </tr>
    </thead>
    <tbody v-if="props.lineRichMenus.length > 0">
      <tr v-for="lineRichMenu of props.lineRichMenus" :key="lineRichMenu.guid">
        <td>
          <RouterLink
            :to="{
              name: 'LineRichMenuEditPage',
              params: {
                entranceGUID: route.params.entranceGUID,
                lineRichMenuGUID: lineRichMenu.guid,
              },
            }"
            >{{ lineRichMenu.label }}
          </RouterLink>
        </td>
        <td>
          <ButtonIconOnly @click="onClickDeleteButton(lineRichMenu)">
            <template #icon>
              <IconDustBox />
            </template>
          </ButtonIconOnly>
        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td colspan="6" :class="$style.none">リッチメニューがありません</td>
      </tr>
    </tbody>
  </table>
</template>

<style module lang="scss">
.table {
  border-collapse: collapse;

  thead {
    background-color: $color-background-base;

    th {
      padding: 12px;
      text-align: left;
    }
  }

  tbody {
    tr {
      &:not(:first-child) {
        border-top: 1px solid $color-border-low-emphasis;
      }

      td {
        padding: 24px 12px;

        a {
          display: block;
          color: inherit;
          text-decoration: underline;
        }
      }
    }
  }
}

.deleteButton {
  width: 50px;
}

.none {
  text-align: center;
}
</style>
